import React from "react";
import { string } from "prop-types";
import { Col } from "../Grid";
import LogoLink from "../LogoLink";

const FooterLogo = ({ logoPath, logoAlt = "" }) => (
	<Col>
		<LogoLink imgSrc={logoPath} alt={logoAlt} />
	</Col>
);

FooterLogo.propTypes = {
	logoPath: string.isRequired,
	logoAlt: string,
};

export default FooterLogo;
